<span class="footer-wrapper small p-1">
  <span class="footer-content">
    <span innerHtml="{{ 'footer_mypascom_name' | i18next }}"></span>
    <span class="ml-1" innerHtml="{{ 'footer_company_name' | i18next }}"></span>
  </span>
</span>
